import { Flex, Text, Badge, Spacer, Box } from '@chakra-ui/react'
import { FC } from 'react'
import { decodeToken } from 'react-jwt'

import useParametrizationRevision from '@hook/parametrization/use-revision'
import useAuth from '@hook/shared/use-auth'
import { TokenProps } from '@provider/Shared/UserAuthProvider'

import ParametrizationRevisionModalApproved from '@component/Parameterization/Revision/ModalApproved'
import ParametrizationRevisionModalReproved from '@component/Parameterization/Revision/ModalReproved'

interface ISelectedTableBar {
  isButtons?: boolean
}

const SelectedTableBar: FC<ISelectedTableBar> = ({ isButtons = true }) => {
  const { selecteds } = useParametrizationRevision()
  const { role } = useAuth()
  const domain = process.env.REACT_APP_AUTH0_DOMAIN
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  )
  const decodedToken = decodeToken(userInfos?.body.access_token) as TokenProps
  const isRevision = decodedToken ? decodedToken.canReviewStatusChange : false
  return (
    <Flex
      height={50}
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="space-between"
      paddingY={2}
      paddingX={6}
    >
      <Flex alignItems="center">
        <Badge
          h="16px"
          minW="16.5px"
          marginRight={2}
          color="#4b64c9"
          border="1px solid #4b64c9"
          background="#c0d9ff"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {selecteds.length}
        </Badge>
        <Text color={'black'}>Itens Selecionados</Text>
      </Flex>

      <Spacer />

      {isButtons ? (
        <>
          {isRevision === 'True' ? (
            <>
              <ParametrizationRevisionModalApproved />

              <Box marginLeft={2}>
                <ParametrizationRevisionModalReproved />
              </Box>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </Flex>
  )
}

export default SelectedTableBar
